import apinode from '../../apinode'

class HistoricoTransferenciaService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(
      `/historico-transferencia/${this.idconta}`,
    )

    return response.data
  }

  async delete(id) {
    await apinode.delete(`/historico-transferencia/${id}/${this.idconta}`)
  }
}

export default new HistoricoTransferenciaService()
